import { Component, OnInit } from '@angular/core'
import { FieldType } from '@ngx-formly/core'
import { MenuItem } from 'primeng/api'

@Component({
  selector: 'app-formly-stepper',
  templateUrl: './formly-stepper.component.html',
  styleUrls: ['./formly-stepper.component.scss'],
})
export class FormlyStepperComponent extends FieldType implements OnInit {
  items: MenuItem[]

  constructor() {
    super()
  }

  ngOnInit() {
    this.items = [{ label: 'Step 1' }, { label: 'Step 2' }, { label: 'Step 3' }]
  }
}
